import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGlobe } from '@/fontawesome'
import SocialMediaSection from '@/components/market-analysis/SocialMediaSection'
import YouTubeVideosSection from '@/components/market-analysis/YouTubeVideosSection'
import BlogArticlesSection from '@/components/market-analysis/BlogArticlesSection'

export default function Social() {
  return (
    <div className="py-8">
      {/* Page Header */}
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-12 h-12 bg-teal-100 dark:bg-teal-900/50 rounded-lg flex items-center justify-center">
            <FontAwesomeIcon icon={faGlobe} className="w-6 h-6 text-teal-600 dark:text-teal-400" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
              Soziales
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Videos und Artikel rund um Trading
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="space-y-8">
        {/* YouTube Videos */}
        <YouTubeVideosSection />

        {/* Blog Articles */}
        <BlogArticlesSection />

        {/* Social Media */}
        <SocialMediaSection />
      </div>
    </div>
  )
}
